import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Sector, Cell } from 'recharts';
import { encryptStorage } from '../constant'

/**
 * PC_Lc_04 getFeedbackData gets imported from api.js file
 */
import { getDomainData, getEvaluationData, getFeedbackData } from '../service/api';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

import '../components/css/Dashboard-styles.css';

// const data = [
//   { name: "Group A", value: 500 },
//   { name: "Group B", value: 400 },
//   { name: "Group C", value: 200 },
//   { name: "Group D", value: 400 },
//   { name: "Group E", value: 300 }
// ];
const COLORS = ['#30C681', '#FFC107', '#DC143C'];

export default function FeedbackData(props) {
    const navigate = useNavigate();

    /**
     * PC_Fc_02
     * The data , role , flagData , DOmain , period , filterValue , filterData ,  filterpressed state variable is created for storing the response data
     */

    const [role, setRole] = useState(encryptStorage.getItem('role'));
    const [flagData, setFlagData] = useState([]);
    const [data, setData] = useState([]);
    const [period, setPeriod] = useState();

    const [evaluationPeriod, setEvaluationPeriod] = useState([]);

    const [domains, setDomains] = useState([]);
    const [filterValue, setFilterValue] = useState("")

    const filterObj = {
        domain: '',
        year: '',
    };

    const [filterData, setFilterData] = useState(filterObj);

    const [filterPressed, setFilterPressed] = useState(false);

    /**
     * PC_FC_03
     * Use Efffect method is called to get role from session and store it
     */

    useEffect(() => {
        setRole(props.role);

        fetchApi();
    }, []);

    /**
     * PC_FC_06
     * The fetchApi function in the useEffects gets invoked which inturn call the getFeedbackData() function with respective parameters
     */

    const fetchApi = async (dataFilter = '') => {
        let resp;

        if (dataFilter.domain || dataFilter.dates) resp = await getFeedbackData(dataFilter, props.role);
        else resp = await getFeedbackData("", props.role);

        if (resp?.data?.ResponseData?.length > 2) {

            setFlagData(resp.data.ResponseData[1]);

            setPeriod(resp.data.ResponseData[2]);

            let percentData = resp.data.ResponseData[0];

            let arr = [];

            Object.keys(percentData).map((el, i) => {
                let ob = {
                    name: el,
                    value: percentData[el],
                };

                arr.push(ob);
            });

            setData(arr);
        }

        const evalPeriod = await getEvaluationData();

        if (evalPeriod?.data?.ResponseData.length > 0) setEvaluationPeriod(evalPeriod.data.ResponseData);

        const domainDrop = await getDomainData();

        if (domainDrop?.data?.ResponseData?.length > 0) setDomains(domainDrop.data.ResponseData);
    };

    const handleClick = (e) => {


        navigate('/TeamDirectory?dashboard=true', {
            state: { flag: e.name, domain: filterData?.domain, start_date: filterData?.dates?.split('||')[0], end_date: filterData?.dates?.split('||')[1] },
        });
    };

    const filterClicked = () => {
        fetchApi(filterData);

        setFilterPressed(true);
    };

    /**
     * PC_FC_10
     * The response data gets stored in the data variable and passed to the PieChart
     */

    return (
        <>

            <div className="d-flex justify-content-between">
                <div className="ps-3">
                    <h1 className="tt-bold font-15 pt-3 mb-1">{(role == 'Hr Manager') ? `Organization's Feedback` : 'Team Feedback'}</h1>

                </div>
                <div className="dropdown my-2 me-2 " style={{ 'z-index': '1' }} >
                    <button
                        className={`btn ${(role == 'Hr Manager') ? 'dashboard-filter-btn' : null}  font-12 medium-text`}
                        type="button"
                        id="dropdownMenuButton126"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        {(filterData.domain && filterPressed && filterData.domain != filterValue) ? `${filterValue}` : (filterData.domain && filterPressed) ? `${filterData.domain}` : (role == 'Hr Manager') ? `ALL` : null}
                        <img src="/Images/Group 1162.svg" alt="dashboard-filter" className="ms-2" />
                    </button>
                    <div className="dropdown-menu dashboard-filter-dropdown px-3 py-3">
                        <div className="row">
                            <div className="d-flex justify-content-between">
                                <h5 className="font-12 bold-text mt-2">Advanced Filter</h5>
                                <button className="btn p-0">
                                    <img src="/Images/Path 38820.svg" />
                                </button>
                            </div>

                            <div className="col-md-12">
                                {(role == 'Hr Manager') ? (
                                    <>
                                        <label className="medium-text font-12 d-flex mb-1">Domain</label>
                                        <select
                                            value={filterData.domain}
                                            onChange={(e) => {
                                                setFilterData((filterData) => ({
                                                    ...filterData,
                                                    [e.target.name]: e.target.value,
                                                }));
                                            }}
                                            className="dashboard-dropbox-style font-12 lable-color2 bold-text p-1"
                                            name="domain"
                                        >
                                            <option selected value="">
                                                Select
                                            </option>
                                            {domains.map((domain) => {
                                                return <option value={domain}>{domain}</option>;
                                            })}
                                        </select>
                                    </>
                                ) : null}
                            </div>

                            <div className="col-md-12">
                                <h5 className="font-12 bold-text mt-3">Evaluation Period</h5>
                                <select
                                    value={filterData.dates}
                                    onChange={(e) => {
                                        setFilterData((filterData) => ({
                                            ...filterData,
                                            [e.target.name]: e.target.value,
                                        }));
                                    }}
                                    className="dashboard-dropbox-style font-12 lable-color2 bold-text p-1"
                                    name="dates"
                                >
                                    <option selected disabled value="">
                                        Evaluation Periods
                                    </option>
                                    {evaluationPeriod.map((evaluation) => {
                                        const valStart = moment(evaluation.start_date).format('YYYY-MM-DD');
                                        const valEnd = moment(evaluation.end_date).format('YYYY-MM-DD');

                                        return (
                                            <option value={valStart + '||' + valEnd}>
                                                {moment(evaluation.start_date).format('DD MMM') +
                                                    '-' +
                                                    moment(evaluation.end_date).format('DD MMM,YYYY')}
                                            </option>
                                        );
                                    })}
                                </select>
                                {/* <div className="col-md-6">
                  <label className="medium-text font-12 d-flex mb-1">From</label>
                  <input type="date" className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1" placeholder="Select Domain" />
                </div>
                <div className="col-md-6">
                  <label className="medium-text font-12 d-flex mb-1">To</label>
                  <input type="date" className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1" placeholder="Select Domain" />
                </div> */}
                            </div>

                            <div className="d-flex justify-content-end mt-3">
                                <a
                                    onClick={() => {
                                        setFilterData(filterObj);
                                        fetchApi(filterObj);
                                        setFilterPressed(false);
                                    }}
                                    className="btn hive-btn-secondary me-3"
                                >
                                    Clear
                                </a>
                                <button
                                    onClick={(e) => {
                                        filterClicked(e);
                                        setFilterValue(filterData.domain)
                                    }}
                                    className="btn hive-btn-primary dashboard-btn-filter"
                                >
                                    Apply
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="ps-3">
                <p className="medium-text font-9 dash-grey mb-1">{`Feedback from ${period} `}</p>
            </div>
            <div className="text-center d-flex mt-4">
                <div className="col-md-7">
                    <PieChart width={300} height={300} style={{ 'margin-top': '-120px', left: '-25px' }}>
                        <Pie
                            data={data}
                            cx={120}
                            cy={200}
                            innerRadius={65}
                            outerRadius={80}
                            // fill="#8884d8"
                            // paddingAngle={5}
                            dataKey="value"
                            onClick={(e) => {
                                handleClick(e);
                            }}
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                    </PieChart>
                </div>
                <div className="col-md-3 ms-3 align-self-center text-start">
                    <div className="d-flex justify-content-between align-items-center">

                        <p className="semibold-text font-11 text-start">
                            <span>
                                <img src="/Images/Green-Flag.svg" className="dashboard-custom-flagsize me-1" />
                            </span>
                            Green
                        </p>
                        <p className="ms-2 font-18 tt-bold text-end">{flagData.green}</p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <p className="semibold-text font-11 text-start">
                            <span>
                                <img src="/Images/Yellow-Flag.svg" className="dashboard-custom-flagsize me-1" />
                            </span>
                            Yellow
                        </p>
                        <p className="ms-2 font-18 tt-bold text-end">{flagData.yellow}</p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <p className="semibold-text font-11 text-start">
                            <span>
                                <img src="/Images/red-flag.svg" className="dashboard-custom-flagsize me-1" />
                            </span>
                            Red
                        </p>
                        <p className="ms-2 font-18 tt-bold text-end">{flagData.red}</p>
                    </div>

                    {/* <div> <p className="semibold-text font-11"><span><img src="/Images/yellow-flag.svg" className="dashboard-custom-flagsize me-2" /></span>yellow </p></div><span className="ms-2 font-18 tt-bold">{flagData.yellow}</span> */}
                    {/* <div> <p className="semibold-text font-11"><span><img src="/Images/red-flag.svg" className="dashboard-custom-flagsize me-2" /></span>red </p> </div><span className="ms-2 font-18 tt-bold">{flagData.red}</span> */}
                </div>
            </div>
            {/* <div className="text-center">
       
      </div> */}
        </>
    );
}
